<template>
    <rkm-modal
        extraLarge
        ref="Modal"
        title="Exames"
    >
        <Form
            :examesModal="this.examesModal"
            :infraestruturaSolicitanteId="this.infraestruturaSolicitanteId"
            :isEdicao="this.isEdicao"
            :reguladorId="this.reguladorId"
            :sexoPaciente="this.sexoPaciente"
            :pacienteId="this.pacienteId"
            :solicitacoesItens="solicitacoesItens"
            ref="Form"
        />
        <List
            :examesModal="this.examesModal"
            :isEdicao="this.isEdicao"
            ref="List"
        />

        <template v-slot:footer="{ cancel }">
            <rkm-button
                :disabled="!!loading"
                @click="cancel"
            >
                Cancelar
            </rkm-button>

            <rkm-button
                :disabled="!!loading"
                @click="handleSave"
                color="primary"
            >
                Salvar
            </rkm-button>
        </template>

    </rkm-modal>
</template>

<script>

// Vuex
import { mapActions, mapGetters } from 'vuex'

// Mixins
import { object } from '@/mixins'

// Components
import Form from './Form'
import List from './List'

export default {

    components: { Form, List },
    computed: {

        ...mapGetters({ loading: 'getLoading' }),
    },
    data: () => ({
        examesModal: [],
    }),
    methods: {

        ...mapActions(['someAction']),
        open() {

            this.examesModal = this.clone(this.exames);
            this.$refs.Modal.show();

        },
        handleSave() {

            this.$emit('addExame', this.examesModal);
            this.$refs.Modal.hide();
        },
    },
    mixins: [ object ],
    props: {
        exames: { type: Array, default: () => [], },
        solicitacoesItens: { type: Array, default: () => [], },
        infraestruturaSolicitanteId: { type: [String, Number], required: true, },
        isEdicao: { type: Boolean, default: false, },
        reguladorId: { type: [String, Number], required: true, },
        sexoPaciente: { type:  [String, Number], required: true, },
        pacienteId: { type: Number, required: true },
    },
}
</script>